// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import {
  EmbroideryFormKind,
  LogoAndTextFormValues,
  TextFormValues,
} from '../../../../../containers/EmbroideryService/types'
import { EmbroideryPlacementDetails } from '../../../../../types/graphql/product'
import { PlacementSelector } from '../../selectors/PlacementSelector'
import { EmbroideryOptionWrapper } from '../../shared-form-styles'

interface Props {
  labelId: string
  placementOptions: EmbroideryPlacementDetails[] | null
  form:
    | Pick<
        FormikContextType<TextFormValues>,
        'setFieldError' | 'setFieldTouched' | 'values' | 'setFieldValue' | 'touched' | 'errors'
      >
    | Pick<
        FormikContextType<LogoAndTextFormValues>,
        'setFieldError' | 'setFieldTouched' | 'values' | 'setFieldValue' | 'touched' | 'errors'
      >
  kind: EmbroideryFormKind | null
}

export const TextPlacement: FC<Props> = ({ labelId, placementOptions, form, kind }) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const { choosePlacement } = EmbroideryService.useContainer()

  const handleSelectPlacement = (placement: EmbroideryPlacementDetails) => {
    choosePlacement(kind, placement)
    form.setFieldValue('textPlacement', placement)
  }

  if (!placementOptions) return null

  return (
    <EmbroideryOptionWrapper>
      <PlacementSelector
        errorMessage={form.touched.textPlacement ? form.errors.textPlacement : undefined}
        label={fixtures.textOption.textPlacementLabel}
        labelId={labelId}
        onSelectPlacement={handleSelectPlacement}
        placementOptions={placementOptions}
        selectedPlacementOption={form.values.textPlacement ?? placementOptions[0]}
      />
    </EmbroideryOptionWrapper>
  )
}
